import { ChangeDetectionStrategy, Component, input } from '@angular/core';

// Inline SVG icons, sized by font-size and colored by currentColor. Add icons as the app needs them.
@Component({
  selector: 'lib-icons',
  templateUrl: './icons.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
    svg {
      width: 1em;
      height: 1em;
      fill: currentColor;
    }
  `,
})
export class IconComponent {
  icon = input.required<'eye' | 'eye-slash' | 'check' | 'square-plus' | 'xmark'>();
}
